// import { HttpClient } from '@angular/common/http';
// import { Injectable, inject, signal } from '@angular/core';
// import { Router } from '@angular/router';
// import { environment } from '../environments/environment';

// export interface LoginResponse {
//   userName: string;
//   emailAddress: string;
//   role: string;
//   token: string;
// }

// @Injectable({ providedIn: 'root' })
// export class AuthService {
//   private http = inject(HttpClient);
//   private router = inject(Router);

//   isAuthenticated = signal<boolean>(!!localStorage.getItem('authToken'));
//   userName = signal<string | null>(localStorage.getItem('authUser'));
//   role = signal<string | null>(localStorage.getItem('authRole'));

//   login(username: string, password: string) {
//     return this.http.post<LoginResponse>(`${environment.apiBase}/api/admin/login`, {
//       username,
//       password,
//     });
//   }

//   setSession(response: LoginResponse) {
//     localStorage.setItem('authUser', response.userName);
//     localStorage.setItem('authRole', response.role);
//     localStorage.setItem('authToken', response.token);
//     this.userName.set(response.userName);
//     this.role.set(response.role);
//     this.isAuthenticated.set(true);
//   }

//   logout() {
//     localStorage.removeItem('authUser');
//     localStorage.removeItem('authRole');
//     localStorage.removeItem('authToken');
//     this.userName.set(null);
//     this.role.set(null);
//     this.isAuthenticated.set(false);
//     this.router.navigate(['/login']);
//   }

//   getToken(): string | null {
//     return localStorage.getItem('authToken');
//   }
// }

import { Injectable, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private oauthService = inject(OAuthService);

  private initialized = false;

  constructor() {
    this.init();
  }

  async init() {
    this.oauthService.configure(authConfig);

    try {
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();
      this.initialized = true;
      console.log('OIDC initialized');
    } catch (e) {
      console.error('OIDC init failed', e);
    }
  }

  async login() {
    console.log('Initiating login');

    // 🔥 IMPORTANT GUARD
    if (!this.initialized) {
      console.warn('OIDC not ready yet. Waiting...');
      await this.init();
    }

      console.log('initialized:', this.initialized);
  console.log('issuer:', this.oauthService.issuer);
  console.log('clientId:', authConfig.clientId);

    this.oauthService.initCodeFlow();
  }

  logout() {
    this.oauthService.logOut();
  }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  getToken(): string {
    return this.oauthService.getAccessToken();
  }
}